import { isDefined, schAlertType, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';

export const effectiveAgeLowerThanActualAge: AlertDefinition = ({
  improvementEntityIds,
  propertyDataEntities,
}) => {
  const faultyProperty = improvementEntityIds
    .map((id, index) => {
      const propertyData =
        id === 'subject'
          ? (propertyDataEntities[id] as SubjectPropertyDataState | undefined)?.subjectData
          : (propertyDataEntities[id] as CompPropertyDataState | undefined)?.compData;

      const { age: actualAge, effectiveAge } = propertyData?.editableData.improvements ?? {};

      return { id, index, actualAge, effectiveAge };
    })
    .find(
      ({ actualAge, effectiveAge }) =>
        isDefined(actualAge) && isDefined(effectiveAge) && effectiveAge > actualAge,
    );

  if (!faultyProperty) return undefined;

  const { id: propertyID, actualAge, effectiveAge } = faultyProperty;
  let propertyName = '';
  if (propertyID === 'subject') {
    if (improvementEntityIds.includes('subjectArv')) {
      propertyName = 'Subject AIV';
    } else {
      propertyName = 'Subject';
    }
    propertyName = 'Subject';
  } else if (propertyID === 'subjectArv') {
    propertyName = 'Subject ARV';
  } else {
    propertyName = `Comparable ${faultyProperty.index}`;
  }

  return {
    type: schAlertType.enum.effectiveAgeLowerThanActualAge,
    status: 'active',
    message: `Effective Age of ${propertyName} (${effectiveAge} years) must be less than or equal to its Actual Age (${actualAge} years).`,
    propertyID,
    fixingInfo: {
      tips: 'Tips: Effective Age cannot exceed the actual chronological age. Provide clear justification if you believe the current entry is appropriate due to unique physical depreciation or other condition-related factors.',
      pairedCostRouteItem: schPairedCostRouteItem.enum.analysis,
    },
  };
};
